import { render, staticRenderFns } from "./MenuDescuentos.vue?vue&type=template&id=9f058e18&scoped=true"
import script from "./MenuDescuentos.vue?vue&type=script&lang=js"
export * from "./MenuDescuentos.vue?vue&type=script&lang=js"
import style0 from "./MenuDescuentos.vue?vue&type=style&index=0&id=9f058e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f058e18",
  null
  
)

export default component.exports